import React from 'react';
import { RotatingLines } from 'react-loader-spinner';

function Loader({ size = 40, speed = '2', color = '#02393E' }) {
	return <RotatingLines visible={true} height={size} width={size} color='red' strokeColor={color} strokeWidth='5' animationDuration={speed} ariaLabel='rotating-lines-loading' wrapperStyle={{}} wrapperClass='' />;
}

export default Loader;
